import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useLanguage } from '../../../../context/LanguageContext';
import Consult from '../../sections/Consult';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../../../routes/paths';
import { Features } from '../../../../assets/features/Features';
import SEO from '../../seo/SEO';
import { seoData } from '../../../../data/seoData';

const PrivacyPage: React.FC = () => {
  const { language } = useLanguage();
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
    
    // Initialize AOS animation library
    AOS.init({
      duration: 1000,
      easing: 'ease-in-out',
      once: true,
      mirror: false
    });
  }, []);

  // Handle appointment button click
  const handleAppointmentClick = () => {
    navigate(ROUTES.HOME);
    setTimeout(() => {
      const appointmentSection = document.getElementById('appointment');
      if (appointmentSection) {
        appointmentSection.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  const privacyContent = Features.privacyPage[language];

  return (
    <>
      <SEO 
        title={seoData.privacy.title}
        description={seoData.privacy.description}
        canonical={seoData.privacy.canonical}
      />
      {/* Hero Section */}
      <section 
        className="privacy-hero d-flex align-items-center" 
        style={{ 
          backgroundColor: '#1977cc',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: '30vh',
          position: 'relative'
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-12 text-center text-white">
              <h1 
                className="display-4 fw-bold" 
                data-aos="fade-up" 
                style={{ 
                  color: '#ffffff', 
                  textShadow: '2px 2px 4px rgba(0, 0, 0, 0.5)'
                }}
              >
                {privacyContent.title}
              </h1>
              <div className="divider mx-auto my-4" data-aos="fade-up" data-aos-delay="100" style={{
                width: '80px',
                height: '4px',
                background: '#ffffff',
                margin: '0 auto'
              }}></div>
              <p className="lead" data-aos="fade-up" data-aos-delay="200">
                {language === 'en' ? 'How we protect your personal information' : 'Como protegemos suas informações pessoais'}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Privacy Content */}
      <section className="privacy-content py-5">
        <div className="container">
          <div className="row">
            <div className="col-lg-10 mx-auto">
              <div className="bg-white p-4 p-md-5 rounded shadow-sm" data-aos="fade-up">
                <h2 className="mb-4">{privacyContent.title}</h2>
                
                <div className="alert alert-info mb-4">
                  <p className="mb-0">
                    <strong>{language === 'en' ? 'Last Updated:' : 'Última Atualização:'}</strong> {language === 'en' ? 'October 26, 1998' : '26 de outubro de 1998'}
                  </p>
                </div>
                
                <div className="mb-4">
                  <p>{privacyContent.introduction}</p>
                </div>
                
                <div className="mb-4">
                  <h4 className="mb-3">{language === 'en' ? 'Data Protection' : 'Proteção de Dados'}</h4>
                  <p>{privacyContent.dataProtection}</p>
                </div>
                
                <div className="mb-4">
                  <h4 className="mb-3">{language === 'en' ? 'Collected Information' : 'Informações Recolhidas'}</h4>
                  <p>{privacyContent.collectedInfo}</p>
                </div>
                
                <div className="mb-4">
                  <h4 className="mb-3">{language === 'en' ? 'Advertisements' : 'Anúncios'}</h4>
                  <p>{privacyContent.advertisements}</p>
                </div>
                
                <div className="mb-4">
                  <h4 className="mb-3">{privacyContent.thirdPartySites}</h4>
                  <p>{privacyContent.thirdPartySitesContent}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Consult Section */}
      <Consult onAppointmentClick={handleAppointmentClick} />
    </>
  );
};

export default PrivacyPage; 